import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  imports: [CommonModule],
  selector: 'ca-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss']
})
export class MultiSelectDropdownComponent implements OnChanges {
  @Input() label = ''; // Label for the dropdown
  @Input() options: KeyLabel[] = []; // Available options
  @Input() selected: Set<string> = new Set<string>(); // Selected values

  @Output() selectionChange = new EventEmitter<Set<string>>(); // Emit when selection changes
  @Output() selectedChange = new EventEmitter<Event>(); // Emit event for stopPropagation

  selectedLabel: string[] = [];
  useLabel = false;
  private elementRef = inject(ElementRef);

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }

  dropdownOpen = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selected'] || changes['options']) {
      this.syncSelectedLabel();
    }
  }

  toggleDropdown(event: Event) {
    event.stopPropagation(); // Prevent closing when clicking inside
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(option: KeyLabel, event: Event) {
    event.stopPropagation(); // Prevent unwanted event bubbling
    console.log('selecting option', option, 'current selection:', this.selected);

    this.selected.has(option.key)
      ? this.selected.delete(option.key)
      : this.selected.add(option.key);

    this.syncSelectedLabel();
    console.log('selected result', this.selected, this.selectedLabel);

    this.selectionChange.emit(this.selected);
    this.selectedChange.emit(event);
  }

  private syncSelectedLabel(): void {
    this.selectedLabel = Array.from(this.selected)
      .map(s => this.options.find(e => e.key === s)?.label)
      .filter((e): e is string => e != undefined);
  }
}
export type KeyLabel = { key: string; label: string; }
